import CryptoJS from "crypto-js"

const config = {
  secret_key: import.meta.env.VITE_ECRYPTO_SECRET_KEY || "superinsegurekey",
  secret_iv: import.meta.env.VITE_ECRYPTO_SECRET_IV || "ultrasuperinsecuresecretiv123418",
  encryption_method: "aes-256-cbc",
}

// Generate secret hash with crypto to use for encryption
const key = CryptoJS.SHA512(config.secret_key).toString(CryptoJS.enc.Hex).substring(0, 32)

const encryptionIV = CryptoJS.SHA512(config.secret_iv).toString(CryptoJS.enc.Hex).substring(0, 16)

/**
 * Método encriptación.
 * @param {string} data - Datos a encriptar.
 */
export const encryptData = (data: string): string => {
  try {
    const dataWithTimestamp = `${data}||${Date.now()}`

    const encrypted = CryptoJS.AES.encrypt(dataWithTimestamp, CryptoJS.enc.Utf8.parse(key), {
      iv: CryptoJS.enc.Utf8.parse(encryptionIV),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    })

    return encrypted.toString()
  } catch (error) {
    console.error("Error encrypting data:", error)
    return ""
  }
}

/**
 * Generate headers for API requests
 */
export const generateApiHeaders = () => {
  const referer = window.location.origin
  const encryptedReferer = encryptData(referer)

  return {
    jiatan: encryptedReferer,
    "app-referer": referer,
    seck1: "bk1k3",
  }
}
